module.exports = __webpack_public_path__ + "img/storyboard_lite_slideshows.d3584e15.png";